import  React  from 'react';

function Footer() {
    return (
    <>
    <footer className='text-center '>
      <div>
        <p className='justify-content-center'>© 2023 ÂnguloZ. Todos os direitos reservados.</p>
      </div>
    </footer>
    </>
    );
}

export default Footer;